import { AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
//import { DxDataGridComponent } from 'devextreme-angular';
//import { EnumValidValueItemModel } from 'src/app/models/enum/enum-valid-value-item.model';
import { AnesthesiaConfigurationModel } from 'src/app/modules/treatment/models/configuration/anesthesia-configuration.model';
import { AnesthesiaEndoAutofillConfigurationModel } from 'src/app/modules/treatment/models/configuration/anesthesia-endo-autofill-configuration.model';
import { AnesthesiaEndoExplosionConfigurationModel } from 'src/app/modules/treatment/models/configuration/anesthesia-endo-explosion-configuration.model';
//import { TreatmentEndoAnesthesiaDataModel } from 'src/app/modules/treatment/models/treatment-endo-anesthesia-data.model';
import { AnesthesiaService } from 'src/app/services/anesthesia.service';
import { DialogService } from 'src/app/services/dialog.service';
import { StaticDataService } from 'src/app/services/static-data.service';
import { TdoTableSelectionEvent } from 'src/app/tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import { TdoTableV2Component } from 'src/app/tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import { ConfigurationService } from '../../configuration.service';
import { AnesthesiaEndoExplosionItemConfigurationModel } from 'src/app/modules/treatment/models/configuration/anesthesia-endo-explosion-item-configuration.model';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'app-anesthesia-autofill-config',
  templateUrl: './anesthesia-autofill-config.component.html',
  styleUrls: ['./anesthesia-autofill-config.component.scss']
})
export class AnesthesiaAutofillConfigComponent implements AfterViewInit, OnInit {
  @ViewChild('afTable') afTable: TdoTableV2Component;
  anesthesiaConfigurationModel: AnesthesiaConfigurationModel;
  selectedAutoFillModel: AnesthesiaEndoAutofillConfigurationModel;
  autoFillList: AnesthesiaEndoAutofillConfigurationModel[] = [];
  isLoading: boolean = true;



  constructor(
    private cd: ChangeDetectorRef,
    private staticDataService: StaticDataService,
    private anesthesiaService: AnesthesiaService,
    public configurationService: ConfigurationService,
    private dialogService: DialogService,
    private snackBar: MatSnackBar) {
  }

  ngOnInit(): void {

    this.anesthesiaService.getAnesthesiaConfigurationModels().subscribe((configRes) => {

      this.anesthesiaConfigurationModel = configRes;
      this.autoFillList = this.anesthesiaConfigurationModel.autoFillConfigs;
      this.selectedAutoFillModel = this.autoFillList[0];

      this.refreshAutoFillItemTableViewData();
    });
  }


  saveAnesthesiaAutoFill() {
    this.isLoading = true;
    this.autoFillList.forEach((item, index) => {
      this.saveAutoFillItem(item, index);
    });
    this.isLoading = false;
    this.configurationService.setClean();
  }

  onNameInputFinished(event) {
    this.selectedAutoFillModel.Name = event;
    this.saveAnesthesiaAutoFill();
  }

  saveAutoFillItem(item: AnesthesiaEndoAutofillConfigurationModel, index: number) {
    this.anesthesiaService.saveAnesthesiaAutoFillConfigurationItem(item)
      .subscribe((ret) => {
        this.autoFillList[index] = ret;
      });
  }

  onDeleteAutoFill(model: AnesthesiaEndoAutofillConfigurationModel) {

    this.dialogService.openConfirmDialog(`Are you sure you want to delete ${model.Name}?`).subscribe((result) => {
      if (result === true) {
        this.anesthesiaService.deleteAnesthesiaAutoFillConfigurationItem(model).subscribe(res => {
          const idx = this.autoFillList.findIndex(p => p.AnesthesiaEndoAutofillID === model.AnesthesiaEndoAutofillID);
          console.log("onDeleteAutoFill", idx, JSON.parse(JSON.stringify(this.autoFillList)));
          if (idx > -1)
            this.autoFillList.splice(idx, 1);
          this.refreshAutoFillItemTableViewData();
          this.selectedAutoFillModel = this.autoFillList[0];
          console.log("onDeleteAutoFill after refresh", idx, JSON.parse(JSON.stringify(this.autoFillList)));
        });
      } else {
        //
      }
    });
  }

  refreshAutoFillItemTableViewData(items: AnesthesiaEndoAutofillConfigurationModel[] = null) {

    const ivl = setInterval(() => {
      if (!this.afTable) {
        return;
      }
      clearInterval(ivl);
      if (items) {
        this.afTable.updateData(items);        
      } else {
        this.afTable.updateData(this.autoFillList);
      }
    }, 10);
  }

  onAutoFillSelected(event: TdoTableSelectionEvent) {
    if (event.row.model)
      this.selectedAutoFillModel = event.row.model as AnesthesiaEndoAutofillConfigurationModel;
    else if (event.model)
      this.selectedAutoFillModel = event.model as AnesthesiaEndoAutofillConfigurationModel;
  }


  onNewAutoFill() {
    const model = new AnesthesiaEndoAutofillConfigurationModel();
    model.Name = "# New AutoFill";

    this.autoFillList.unshift(model);
    this.refreshAutoFillItemTableViewData();
    this.selectedAutoFillModel = this.autoFillList[0] as AnesthesiaEndoAutofillConfigurationModel;
  }

  ngAfterViewInit(): void {
    if (!this.staticDataService.isReady) {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.isLoading = false;
        }
      });
    } else {
      this.isLoading = false;
    }
  }
}
